import React, { useEffect, useState } from "react";
import "../css/contacts.scss";
import SectionLoader from "../../../../components/global/loader/SectionLoader";
import { convertDateAndTimeToString } from "../../../../utils/HelperFunctions";
import { useNavigate } from "react-router-dom";
import RoutingPaths from "../../../../utils/RoutingPaths";
import { getClientAvailableBalance } from "../../../../services/api_services/PaymentService";
import { SEARCH_RESULT_FOR_CREDIT_WALLET } from "../../../../utils/Constants";

let paymentId = 0;
const setPaymentId = (value) => {
  paymentId = value;
};
export { setPaymentId, paymentId };

let refundId = 0;
const setRefundId = (value) => {
  refundId = value;
};
export { setRefundId, refundId };

export default function DocProWallet(props) {
  const navigate = useNavigate();

  const client = JSON.parse(sessionStorage.getItem("ClientDetails"));

  const isClientUser = client !== null;

  const consultant = JSON.parse(sessionStorage.getItem("ConsultantDetails"));
  const isConsultantUser = consultant !== null;

  const [isCreditWalletAPILoading, setIsCreditWalletAPILoading] =
    useState(false);
  const [creditWalletList, setCreditWalletList] = useState([]);
  const [creditWalletBalance, setCreditWalletBalance] = useState(0);
  useState(0);

  useEffect(() => {
    getCreditWalletList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCreditWalletList = async () => {
    setIsCreditWalletAPILoading(true);
    const response = await getClientAvailableBalance(props.clientId);
    if (response) {
      setCreditWalletList(response.data.creditWalletEntryList);
      setCreditWalletBalance(response.data.totalCreditBalance);
    }
    setIsCreditWalletAPILoading(false);
  };

  return (
    <>
      {isCreditWalletAPILoading ? (
        <SectionLoader />
      ) : (
        <>
          {creditWalletList.length > 0 ? (
            <div className="mt-5">
              <h5 className="mt-3 credit-wallet-balance txt-primary d-flex flex-column flex-md-row  gap-2">
                <span>Available Credit Wallet Balance :</span>
                <span className="txt-success ms-3">
                  ₹ {parseFloat(creditWalletBalance).toFixed(2)}
                </span>
              </h5>
              {creditWalletList.map((wallet) => {
                return (
                  <div
                    className="prescription-details-tile mt-3 "
                    key={wallet.id}
                  >
                    <div className="">
                      <p className="details-tile text-capitalize">
                        <span>Credit Amount:</span>
                        {parseFloat(wallet.creditAmount).toFixed(2)}
                      </p>

                      <p className="details-tile text-capitalize">
                        <span>Used Balance :</span>
                        {parseFloat(
                          wallet.creditAmount - wallet.availableCreditBalance
                        ).toFixed(2)}
                      </p>

                      <p className="details-tile text-capitalize">
                        <span>Available Balance :</span>
                        {parseFloat(wallet.availableCreditBalance).toFixed(2)}
                      </p>

                      <p className="details-tile text-capitalize">
                        <span>Payment Reference:</span>

                        {isClientUser ||
                        (isConsultantUser &&
                          (consultant.isPaymentInfoAccessAllowed === true ||
                            consultant.isPaymentInfoAccessAllowed === null)) ? (
                          <React.Fragment>{wallet.paymentId}</React.Fragment>
                        ) : (
                          <React.Fragment>
                            <button
                              className="bg-transparent txt-primary text-capitalize p-0 "
                              style={{ border: 0, textDecoration: "underline" }}
                              onClick={() => {
                                setPaymentId(wallet.paymentId);
                                navigate(RoutingPaths.PAYMENTS);
                              }}
                            >
                              {wallet.paymentId}
                            </button>
                          </React.Fragment>
                        )}
                      </p>
                      <div className="details-tile text-capitalize">
                        <span>Payment Usage Reference:</span>
                        {wallet.usageReferencePaymentIdList &&
                        wallet.usageReferencePaymentIdList.length > 0 ? (
                          <React.Fragment>
                            {wallet.usageReferencePaymentIdList.map(
                              (paymentIds, index) => (
                                <React.Fragment key={"paymentIds" + index}>
                                  {isClientUser ||
                                  (isConsultantUser &&
                                    (consultant.isPaymentInfoAccessAllowed ===
                                      true ||
                                      consultant.isPaymentInfoAccessAllowed ===
                                        null)) ? (
                                    <React.Fragment>
                                      {" "}
                                      {paymentIds}
                                      {wallet.usageReferencePaymentIdList
                                        .length -
                                        1 >
                                      index
                                        ? ` , `
                                        : " "}
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <button
                                        className="bg-transparent txt-primary text-capitalize p-0"
                                        style={{
                                          border: 0,
                                          textDecoration: "underline",
                                        }}
                                        onClick={() => {
                                          setPaymentId(paymentIds);
                                          navigate(RoutingPaths.PAYMENTS);
                                        }}
                                      >
                                        {paymentIds}
                                      </button>
                                      {wallet.usageReferencePaymentIdList
                                        .length -
                                        1 >
                                      index
                                        ? ` , `
                                        : " "}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment> Not available</React.Fragment>
                        )}
                      </div>

                      <div className="details-tile text-capitalize">
                        <span>Refund Reference:</span>
                        {wallet.usageReferenceRefundIdList &&
                        wallet.usageReferenceRefundIdList.length > 0 ? (
                          <React.Fragment>
                            {wallet.usageReferenceRefundIdList.map(
                              (refundIds, index) => (
                                <React.Fragment key={"refundIds" + index}>
                                  {isClientUser ||
                                  (isConsultantUser &&
                                    (consultant.isPaymentInfoAccessAllowed ===
                                      true ||
                                      consultant.isPaymentInfoAccessAllowed ===
                                        null)) ? (
                                    <React.Fragment>
                                      {" "}
                                      {refundIds}
                                      {wallet.usageReferenceRefundIdList
                                        .length -
                                        1 >
                                      index
                                        ? ` , `
                                        : " "}
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <button
                                        className="bg-transparent txt-primary text-capitalize p-0"
                                        style={{
                                          border: 0,
                                          textDecoration: "underline",
                                        }}
                                        onClick={() => {
                                          setRefundId(refundIds);
                                          navigate(RoutingPaths.PAYMENTS, {
                                            state: { activeTab: "Refunds" },
                                          });
                                        }}
                                      >
                                        {refundIds}
                                      </button>
                                      {wallet.usageReferencePaymentIdList
                                        .length -
                                        1 >
                                      index
                                        ? ` , `
                                        : " "}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment> Not available</React.Fragment>
                        )}
                      </div>

                      <p className="details-tile text-capitalize">
                        <span>Credit Date:</span>
                        {wallet.creditDate === null
                          ? "-"
                          : convertDateAndTimeToString(wallet.creditDate)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="mt-5 ms-0">{SEARCH_RESULT_FOR_CREDIT_WALLET}</p>
          )}
        </>
      )}
    </>
  );
}
